enum AppointmentServiceErrorCode {
  RESOURCE_CALENDAR_INTEGRATION_NOT_FOUND = 'RESOURCE_CALENDAR_INTEGRATION_NOT_FOUND',
}

export { AppointmentServiceErrorCode }
